import { RootState } from '@core/Store'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { ClosestVenue } from '@core/Areas/VenueMode/Utils/geoFenceUtils'

export interface GeoLocation {
  latitude?: number
  longitude?: number
  isoCode: string
  accuracy: number | null
  timestamp: number
  mocked?: boolean
  isEnabledHighAccuracy?: boolean
  closestVenue?: ClosestVenue
}

export const geoLocationInitialState: GeoLocation = {
  latitude: undefined,
  longitude: undefined,
  isoCode: '',
  accuracy: null,
  timestamp: 0,
  mocked: undefined,
  isEnabledHighAccuracy: undefined,
  closestVenue: undefined,
}

const geoLocationSlice = createSlice({
  name: 'geo-location',
  initialState: geoLocationInitialState,
  reducers: {
    setCoords(state, { payload }: PayloadAction<GeoLocation>) {
      // Bulk update
      return { ...state, ...payload }
    },
    setIsEnabledHighAccuracy(state, action: PayloadAction<boolean>) {
      state.isEnabledHighAccuracy = action.payload
    },
  },
})

export const { setCoords, setIsEnabledHighAccuracy } = geoLocationSlice.actions

export default persistReducer(
  {
    key: 'geo-location',
    storage,
    // debug: !PRODUCTION
  },
  geoLocationSlice.reducer
)

export const getCoords = (state: RootState) => state.geoLocation
